import { useEffect, useState } from 'react';
import { useOpticianNotificationsListMutation } from './dashoardApi';
import {
    Badge,
    Button,
    Card,
    Col,
    Container,
    Row,
    Tab,
    Nav,
    Tabs,
    ListGroup,
    Spinner,
} from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import notifBell from '../../Assets/Img/notifBell.png';
import { getTimeDifference } from '../../helper';
import { Link, useNavigate } from 'react-router';

const Notification = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [opticianNotificationsList] = useOpticianNotificationsListMutation();
    const [loading, setLoading] = useState(true);

    const [notificationList, setNotificationList] = useState([]);
    // const [unreadNotificationList, setUnreadNotificationList] = useState([
    //     { heading: 'Your Notification Heading', content: 'lorem ipsum dolor sit amet, consectetur', time: '15mins' },
    //     { heading: 'Your Notification Heading', content: 'lorem ipsum dolor sit amet, consectetur', time: '15mins' },
    //     { heading: 'Your Notification Heading', content: 'lorem ipsum dolor sit amet, consectetur', time: '15mins' },
    // ])

    useEffect(() => {
        opticianNotificationsList().then(({ data }) => {
            setNotificationList(data);
            setLoading(false);
        });
    }, []);

    // Nouveau commentaire  0 mailto:Symoptic@2022
    // Ordonnance partagée 1
    return (
        <>
            <Card className="mb-4">
                <Card.Header
                    className="bg-transparent d-flex align-items-center"
                    style={{ height: '50px' }}
                >
                    <div className="d-flex align-items-center">
                        <Card.Title className="mb-0">
                            {t('notification')}
                        </Card.Title>
                    </div>
                </Card.Header>
                <Card.Body >
                    {loading ? (
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        >
                            <Spinner animation="border" role="status">
                                <span className="visually-hidden">
                                    Loading...
                                </span>
                            </Spinner>
                        </div>
                    ) : (
                        <div className="notifPanelFixedHeight">
                            <ListGroup variant="flush">
                                {notificationList &&
                                notificationList.length > 0 ? (
                                    notificationList.map((item, index) => (
                                        <ListGroup.Item
                                            key={index}
                                            style={{ cursor: 'pointer' }}
                                            onClick={() => {
                                                if (
                                                    item.prescriptionToOptician ==
                                                    '0'
                                                ) {
                                                    navigate('/eyetest/view', {
                                                        state: {
                                                            id: item.testid,
                                                            edit: false,
                                                        },
                                                    });
                                                } else {
                                                    navigate('/prescription', {
                                                        state: {
                                                            id: item.testid,
                                                        },
                                                    });
                                                }
                                            }}
                                        >
                                            <div className="d-flex notificationEntry align-items-center justify-content-start gap-3">
                                                <img src={notifBell} />
                                                <div className="d-flex flex-column gap-1">
                                                    <h2>
                                                        {item.prescriptionToOptician ==
                                                        '0'
                                                            ? 'Nouveau commentaire'
                                                            : 'Ordonnance partagée'}
                                                    </h2>
                                                    <h4>
                                                        {item.prescriptionToOptician ==
                                                        '0'
                                                            ? item.opticiancomment
                                                            : ''}
                                                    </h4>
                                                    <h4>
                                                        Test de :{' '}
                                                        {item.patientName}
                                                    </h4>
                                                    <p>
                                                        {getTimeDifference(
                                                            item.opticiancommentdate
                                                        )}
                                                    </p>
                                                </div>
                                            </div>
                                        </ListGroup.Item>
                                    ))
                                ) : (
                                    <Card.Text>
                                        {t('noNotificationMessage')}
                                    </Card.Text>
                                )}
                            </ListGroup>
                        </div>
                    )}

                    {/* <Row>
                        <Col>
                            <Tab.Container
                                id="notification-tab"
                                defaultActiveKey="read"
                            >
                                <Col>
                                    <Row>
                                        <Col className="d-flex justify-content-between align-items-center">
                                            <div>
                                                <Nav variant="pills" className="d-flex p-0">
                                                    <Nav.Item>
                                                        <Nav.Link eventKey="read">{t("AllRead")}</Nav.Link>
                                                    </Nav.Item>
                                                    <Nav.Item>
                                                        <Nav.Link eventKey="unread">{t("Unread")}</Nav.Link>
                                                    </Nav.Item>
                                                </Nav>
                                            </div>
                                            <Button variant="link" className="text-decoration-none p-0">
                                                <Nav.Link eventKey="clear">Clear All</Nav.Link>
                                            </Button>
                                        </Col>
                                    </Row>
                                    <Row className="mt-3 notifPanelFixedHeight">
                                        <Tab.Content className="p-0">
                                            <Tab.Pane eventKey="read">
                                                <ListGroup variant="flush">
                                                    {readNotificationList.map((notif, index) => (
                                                        <ListGroup.Item key={index}>
                                                            <div className="d-flex notificationEntry align-items-center justify-content-start gap-3">
                                                                <img src={notifBell} />
                                                                <div className="d-flex flex-column gap-1">
                                                                    <h2>{notif.heading}</h2>
                                                                    <h4>{notif.content}</h4>
                                                                    <p>{notif.time}</p>
                                                                </div>
                                                            </div>
                                                        </ListGroup.Item>
                                                    ))}
                                                </ListGroup>
                                            </Tab.Pane>
                                            <Tab.Pane eventKey="unread">
                                                <ListGroup variant="flush">
                                                    {unreadNotificationList.map((notif, index) => (
                                                        <ListGroup.Item key={index}>
                                                            <div className="d-flex notificationEntry align-items-center justify-content-start gap-3">
                                                                <img src={notifBell} />
                                                                <div className="d-flex flex-column gap-1">
                                                                    <h2>{notif.heading}</h2>
                                                                    <h4>{notif.content}</h4>
                                                                    <p>{notif.time}</p>
                                                                </div>
                                                            </div>
                                                        </ListGroup.Item>
                                                    ))}
                                                </ListGroup>
                                            </Tab.Pane>
                                        </Tab.Content>
                                    </Row>
                                </Col>

                            </Tab.Container>
                        </Col>
                    </Row> */}
                </Card.Body>
            </Card>
        </>
    );
};

export default Notification;
